import { GradingCurve } from '../domain/types'

// eslint-disable-next-line import/no-anonymous-default-export
export default function (gradingCurve: GradingCurve, removeId: boolean = true) {
  const { id, dMax, ...data } = gradingCurve
  return removeId ? data as GradingCurve : { ...data, id } as GradingCurve
}
